import React, { FC } from 'react';

type PopupProps = {
   handlePopup:() =>void,
   lang:string
    }
export const Popup: FC<PopupProps> = ({ handlePopup, lang }) => {
  // eslint-disable-next-line react/jsx-props-no-spreading

  const getLanguage = () => {
    switch (lang) {
      case 'en':

        return (
          <p>
            Lastest technology works best on the latest hardware. But don’t worry, you can also
            discover our native wildlife in slightly reduced quality on older AR-enabled devices.
            <span onClick={handlePopup} role="button" tabIndex={0}>OK!</span>
          </p>
        );

      case 'pl':

        return (
          <p>
            Najnowsza technologia działa najlepiej na najnowszym sprzęcie. Ale proszę
            się nie martwić, można również odkrywać naszą rodzimą faunę i florę w nieco gorszej
            jakości na starszych urządzeniach z obsługą AR.
            <span onClick={handlePopup} role="button" tabIndex={0}>OK!</span>
          </p>
        );
      default:
        return (
          <p>
            Neueste Technologie funktioniert am besten auf der neuesten Hardware.
            Aber keine Sorge, auch auf älteren AR-fähigen Geräten können Sie unsere
            heimische Tierwelt in leicht reduzierter Qualität erleben.
            <span onClick={handlePopup} role="button" tabIndex={0}>OK!</span>
          </p>
        );
    }
  };
  return (
    <div className="pop-up">
      {getLanguage()}

    </div>
  );
};
